import axios from 'axios';

const baseUrl = process.env.REACT_APP_API_URL;

export const axiosPublic = (endpoint, data, method = 'GET') => {
	const url = `${baseUrl}/${endpoint}`;
	const headers = { 'Content-Type': 'aplication/json' };

	switch (method) {
		case 'GET':
			if (data) {
				return axios.get(url, { headers, params: data });
			}
			return axios.get(url, { headers });

		case 'POST':
			return axios.post(url, data);

		case 'PUT':
			return axios.put(url, data, { headers });

		case 'DELETE':
			return axios.delete(url, { headers });

		default:
			throw new Error('Método no soportado');
	}
};

export const axiosPdf = (endpoint, data) => {
	const url = `${baseUrl}/${endpoint}`;
	const headers = { 'Content-Type': 'aplication/json' };

	return axios.get(url, { headers, params: data, responseType: 'blob' });
};

export const axiosImg = (endpoint, data, id) => {
	const url = `${baseUrl}/${endpoint}`;
	const headers = { 'Content-Type': 'image/jpeg' };

	return axios.post(url, { headers, data, params: id });
};
